<template>
  <vs-popup fullscreen :active.sync="isSidebarActiveLocal"
    :title=" Object.entries(this.data).length === 1 ? 'Yeni Mood' : 'Mood Düzenle'" v-esc="escape">
    <vs-row vs-type="flex" vs-w="12">
      <vs-col vs-w="3" class="px-2">
        <div @keyup.enter="submitData">
          <template v-if="data.imageUrl">

            <!-- Image Container -->
            <div class="img-container w-64 mx-auto flex items-center justify-center">
              <img v-if="!needUpload" :src="$baseUrl + '/' + data.imageUrl" alt="img" class="responsive">
              <img v-else :src="data.imageUrl" alt="img" class="responsive">
            </div>

            <!-- Image upload Buttons -->
            <div class="modify-img flex justify-between mt-5">
              <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
              <vs-button class="mr-4" type="gradient" @click="$refs.updateImgInput.click()">Fotoğrafı Güncelle
              </vs-button>
              <vs-button type="gradient" color="danger"
                @click="data.imageUrl = null;needUpload=false;productPhotoBinary=null;">
                Fotoğrafı Sil

              </vs-button>
            </div>
          </template>

          <div class="upload-img" v-if="!data.imageUrl">
            <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="w-full" icon-pack="feather" icon="icon-arrow-up" @click="$refs.uploadImgInput.click()">
              Fotoğraf Yükle
            </vs-button>

          </div>

          <vs-row class="mb-6">
            <vs-col class="w-full">
              <vs-textarea id="description" name="Açıklama" v-model="data.description" class="w-full mt-1"
                label="Açıklama" />
            </vs-col>
          </vs-row>

          <vs-row class="mb-6 " vs-type="flex" vs-w="12">
            <vs-col class="w-full" vs-justify="space-between" vs-type="flex">
              <vs-button size="large" class="mr-3 mb-2 " type="gradient" color="danger"
                @click="isSidebarActiveLocal = false">
                Vazgeç
              </vs-button>
              <vs-button size="large" class="mb-2 " type="gradient" color="success" @click="submitData">Kaydet

              </vs-button>

            </vs-col>
          </vs-row>
        </div>
      </vs-col>
      
      <vs-row>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>
  
  <script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import {CreateMood,UpdateMood} from "@/api/MoodProfileImage.js";
    import {
    uploadImage
  } from "@/api/Product";
import { th } from 'vuejs-datepicker/src/locale';
    export default {
      props: {
        isSidebarActive: {
          type: Boolean,
          required: true
        },
        data: {
          type: Object,
          default: () => {},
        }
      },
      data() {
  
        return {
          newMood: {},
          settings: { // perfectscrollbar settings
            maxScrollbarLength: 60,
            wheelSpeed: .60,
          },
          needUpload: false,
          productPhotoBinary: ""
        }
      },
      computed: {
        isSidebarActiveLocal: {
          get() {
            return this.isSidebarActive
          },
          set(val) {
            if (!val) {
              this.$emit('closeSidebar')
              this.$validator.reset()
              this.initValues()
            }
          }
        }
      },
      methods: {
        escape(){
          if(this.isSidebarActiveLocal = true) this.isSidebarActiveLocal = false;
        },
        initValues() {
          this.newMood = {};
        },
        submitData: async function () {
            if ((this.data.imageUrl !== null || this.data.imageUrl != "") && this.needUpload === true) {
            await this.uploadImage();
          } else if (this.data.imageUrl == null || this.data.imageUrl == "") {
            this.$vs.notify({
              color: "danger",
              title: "Hata : ",
              text: "Fotoğraf Seçmeniz Gerekiyor !"
            });
            return;
          }
          if (this.data.id) {
            UpdateMood(this.data).then(res => {
             if (res && res.status === 200) {
               this.$vs.notify({
                   color: "success",
                   title: "Başarılı !",
                   text: "Mood Güncelleme Başarılı !"
                 });
             } else {
               this.$vs.notify({
                 color: "danger",
                 title: "Hata : " + res.status,
                 text: "Mood Güncelleme Başarısız !"
               });
             }
            }).catch(err => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Ürün Güncelleme Başarısız ! "
              });
            });
          }else{
            this.data.id = 0;
            CreateMood(this.data).then(res => {
              if (res && res.status === 200) {
                this.$vs.notify({
                    color: "success",
                    title: "Başarılı",
                    text: "Mood Ekleme Başarılı !"
                  });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Mood Ekleme Başarısız !"
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !"
              });
            });
          }
        },
        updateCurrImg(input) {
        this.needUpload = true;
        if (input.target.files && input.target.files[0]) {
          var reader = new FileReader();
          reader.onload = e => {
            this.data.imageUrl = e.target.result;
          };
          reader.readAsDataURL(input.target.files[0]);
          this.productPhotoBinary = input.target.files[0];
        }
      },
      uploadImage: async function () {
        let image = this.productPhotoBinary;
        let formData = new FormData();
        formData.append("image", image);
        await uploadImage(formData).then(res => {
          if (res && res.status == 200) {
            this.data.imageUrl = "StaticFiles/images/" + res.data;
            this.needUpload = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Seçilen Fotoğraf Yüklenemedi !"
            });
          }
        });
      },
      deleteImage(){
        this.data.imageUrl=null;
        this.needUpload=false;
        this.productPhotoBinary=null;
      }
      },
      components: {
        VuePerfectScrollbar
      },
      watch: {
        isSidebarActive: function (val) {
          if (!val) return
          if (Object.entries(this.data).length === 0) {
            this.initValues();
            this.$validator.reset();
          } else {
            Object.assign(this.newMood, this.data); //Şurda.
            this.needUpload = false;
          }
        },
      },
      mounted: function () {},
      created: async function () {}
    }
  
  </script>
  
  <style lang="scss" scoped>
    .style-chooser .vs__dropdown-menu {
      background: #dfe5fb;
      border: none;
      color: red;
      text-transform: lowercase;
      font-variant: small-caps;
    }
  
    .add-new-data-sidebar {
      ::v-deep .vs-sidebar--background {
        z-index: 52010;
      }
  
      ::v-deep .vs-sidebar {
        z-index: 52010;
        width: 400px;
        max-width: 90vw;
  
        .img-upload {
          margin-top: 2rem;
  
          .con-img-upload {
            padding: 0;
          }
  
          .con-input-upload {
            width: 100%;
            margin: 0;
          }
        }
      }
    }
  
    .tabPager {
      background-color: darkgreen;
      border-radius: 50%;
    }
  
  </style>
  
  <style>
  .vs__dropdown-menu {
      max-height: 25vh !important;
      overflow-x: hidden !important;
      overflow-y: scroll !important;
    }
  </style>
  